// import forge from 'node-forge';

// // Encryption Key
// const key = forge.util.createBuffer('wizphyza', 'utf8');

// // IV
// // const iv = forge.util.createBuffer([10, 20, 30, 40, 50, 60, 70, 80]);
// const iv = forge.util.createBuffer('10,20,30,40,50,60,70,80', 'utf8');

// // Function to encrypt the string
// export function encryptData(strData) {
//   const cipher = forge.cipher.createCipher('DES-CBC', key);
//   cipher.start({ iv: iv });
//   cipher.update(forge.util.createBuffer(strData, 'utf8'));
//   cipher.finish();

//   const encryptedBytes = cipher.output.getBytes();

//   // Convert the bytes to base64
//   const encryptedString = forge.util.encode64(encryptedBytes);
//   console.log('E Data:', encryptedString);

//   return encryptedString;
// }


// public static string EncryptData(string strData)
//     {
//         byte[] key = { }; //Encryption Key
//         byte[] IV = {
//             10,
//             20,
//             30,
//             40,
//             50,
//             60,
//             70,
//             80
//           };
//         byte[] inputByteArray;
//         try
//         {
//             key = Encoding.UTF8.GetBytes(Encryptdecryptkey);
//             // DESCryptoServiceProvider is a cryptography class defind in c#.
//             DESCryptoServiceProvider ObjDES = new DESCryptoServiceProvider();
//             inputByteArray = Encoding.UTF8.GetBytes(strData);
//             MemoryStream Objmst = new MemoryStream();
//             CryptoStream Objcs = new CryptoStream(Objmst, ObjDES.CreateEncryptor(key, IV), CryptoStreamMode.Write);
//             Objcs.Write(inputByteArray, 0, inputByteArray.Length);
//             Objcs.FlushFinalBlock();
//             return Convert.ToBase64String(Objmst.ToArray()); //encrypted string
//         }
//         catch (System.Exception ex)
//         {
//             throw ex;
// ​
//             //EncryptTextResult.text = ex;
//         }
//     }

const CryptoJS = require("crypto-js");
const Encryptdecryptkey = "wizphyza";
export function encryptData(strData) {
  console.log("inside encrypt func",strData)

  let key = []; //Encryption Key
  let IV = [
    10,
    20,
    30,
    40,
    50,
    60,
    70,
    80
  ];
  let inputByteArray;
  try {
    key = new TextEncoder().encode(Encryptdecryptkey);
    // CryptoJS is a JavaScript library for cryptographic operations.
    const encrypted = CryptoJS.DES.encrypt(strData, CryptoJS.lib.WordArray.create(key), {
      iv: CryptoJS.lib.WordArray.create(IV)
    });
    console.log("checkpoint")
    console.log("output ",encrypted.toString())
    return encrypted.toString(); //encrypted string
  } catch (ex) {
    throw ex;
  }
}
function DecryptData(strData) {
    let key = []; // Key
    let IV = [
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80
    ];
    try {
        key = new TextEncoder().encode(Encryptdecryptkey);
        // CryptoJS is a JavaScript library for cryptographic operations.
        let decrypted = CryptoJS.DES.decrypt(strData, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Utf8.parse(IV),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (ex) {
        throw ex;
    }
}